export * from './iconFontAwesomeSciencefictionRocket';
export * from './iconFontAwesomeSciencefictionRobot';
export * from './iconFontAwesomeSciencefictionUserAstronaut';
export * from './iconFontAwesomeSciencefictionJedi';
export * from './iconFontAwesomeSciencefictionHandSpock';
export * from './iconFontAwesomeSciencefictionExplosion';
export * from './iconFontAwesomeSciencefictionBookJournalWhills';
export * from './iconFontAwesomeSciencefictionAtom';
export * from './iconFontAwesomeSciencefictionSpaceAwesome';
export * from './iconFontAwesomeSciencefictionOldRepublic';
export * from './iconFontAwesomeSciencefictionJediOrder';
export * from './iconFontAwesomeSciencefictionGalacticSenate';
export * from './iconFontAwesomeSciencefictionGalacticRepublic';
